<template>
  <div>
    <h5 class="text-center">Indiquez le nom et l'adresse de votre boutique.</h5>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            Nom
          </label>
          <input class="form-control"
                 type="text"
                 name="name"
                 v-validate="modelValidations.name"
                 v-model="model.name"
                 placeholder="Nom de votre boutique"
          />
          <small class="text-danger" v-show="name.invalid">
            {{ getError('name') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            Adresse
          </label>
          <input type="text"
                 name="address"
                 v-validate="modelValidations.address"
                 v-model="model.address"
                 placeholder="Adresse de votre boutique"
                 debounce="2000"
                 class="form-control">
          <small class="text-danger" v-show="address.invalid">
            {{ getError('address') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Carte</h4>
          </div>
          <div class="card-content">
            <div id="map" class="map"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import GoogleMap from '@/google-map'
  import _ from 'lodash'

  let map = null
  let marker = null

  export default {
    computed: {
      ...mapFields(['name', 'address'])
    },
    data () {
      return {
        model: {
          name: '',
          address: ''
        },
        modelValidations: {
          name: {
            required: true
          },
          address: {
            required: true
          }
        }
      }
    },
    watch: {
      'model.address': _.debounce((val) => {
        console.log(val)
        this.a.methods.codeAddress(val)
      }, 1000)
    },
    mounted () {
      map = GoogleMap.init(document.getElementById('map'))
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      },
      codeAddress (address) {
        console.log(address)
        GoogleMap.geocode(address, (results) => {
          map.setCenter(results[0].geometry.location)
          if (marker) marker.setMap(null)
          marker = GoogleMap.marker({
            title: 'Ma boutique',
            position: results[0].geometry.location
          })
          marker.setMap(map)
        }, (error) => {
          console.error(error)
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Store/Add/FirstStep.vue